// Navbar.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import "./styles.css";
import Menu from "../menuComponent/menu";

const Navbar = ({ showMenu = true }) => {
  return (
    <div className='navHead'>
      <div className='navHead_icn'>
        <img
          className='dia_img'
          src="/assests/images/MadhuNetrAI Logo.png"
          alt='Diabetic Retinopathy'
        />
        <img
          className='gov_img'
          src="/assests/images/New-Logos.png"
          alt='Indian Government'
        />
      </div>
      <div className='navMenu'>
        {showMenu && <Menu />}
      </div>
    </div>
  );
};

export default Navbar;
